import { render } from "./Employee.vue?vue&type=template&id=894d7e7c&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=894d7e7c&lang=scss&scoped=true"
import "./Employee.vue?vue&type=style&index=1&id=894d7e7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894d7e7c"]])

export default __exports__